import { Modal } from "antd";
import styled, { css } from 'styled-components';

export const CustomModal = styled(Modal)`
  @keyframes slideIn {
    0% {
      transform: translateX(100%) translateY(-50%);
      opacity: 0;
    }
    100% {
      transform: translateX(0) translateY(-50%);
      opacity: 1;
    }
  }
  @keyframes slideOut {
    0% {
      transform: translateX(0%) translateY(-50%);
    }
    50% {
      opacity: 1;
    }
    100% {
      transform: translateX(100%) translateY(-50%);
      opacity: 0;
    }
  }
  .ant-modal-body {
    scrollbar-width: none;    
  }

  &.ant-modal-slide-in-enter,
  &.ant-modal-slide-in-appear {
    opacity: 0;
    animation-duration: 0.8s;
    animation-fill-mode: both;
  }
  &.ant-modal-slide-in-leave {
    opacity: 1;
    animation-duration: 0.8s;
    animation-fill-mode: both;
  }
  &.ant-modal-slide-in-enter.ant-modal-slide-in-enter-active,
  &.ant-modal-slide-in-appear.ant-modal-slide-in-appear-active {
    animation-name: slideIn;
  }
  &.ant-modal-slide-in-leave.ant-modal-slide-in-leave-active {
    animation-name: slideOut;
  }
`;

const overflowScroll = css`
  overflow-y: scroll;
  scrollbar-width: none;
  ::-webkit-scrollbar {
    display: none;
  }
`;

export const SearchSelectContainer = styled.div`
  position: relative;
  width: ${({ searchSelectFocus }) => searchSelectFocus ?'100%' :'50%'}; 
  transition: all .5s;
  // max-width: 400px;
  margin: 5px 0px;
  font-family: Arial, sans-serif;

  .search-input-wrapper {
    display: flex;
    flex-wrap: ${({ isFocused }) => (isFocused? "wrap" : "unset")};
    gap: 5px;
    padding: 5px;
    border: 1px solid #ccc;
    border-radius: 5px;
    background: #fff;
    max-height: ${({ isFocused, tags }) => (isFocused || tags.length <= 2 ? "auto" : "38px")};
    overflow: hidden;
    white-space: ${({ isFocused }) => (isFocused? "unset" : "nowrap")};
  }
  .highlight {
    
    z-index: 1000;
    box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  }
  .bubble-container{
    max-height: 35px;
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
    overflow: auto;
  }
  .filter-bubble {
    background: #917bf7;
    color: white;
    padding: 4px 8px;
    border-radius: 15px;
    display: flex;
    align-items: center;
    gap: 5px;
    width: fit-content;
    font-size: 12px;
    text-transform: capitalize;
    span{
      font-weight: bold;
    }
  }
  .search-input {
    border: none;
    outline: none;
    flex: 1;
    min-width: 100px;
    font-size: 14px;
    padding: 4px;
    height: 26px;
  }
  .filter-bubble button {
    background: transparent;
    border: none;
    color: white;
    font-weight: bold;
    cursor: pointer;
  }

  .options-list {
    ${overflowScroll};
    position: absolute;
    top: 100%; /* Places the dropdown just below the input */
    left: 0;
    width: 100%;

    border-radius: 5px;
    margin-top: 5px;
    background: white;
    max-height: 150px;
    overflow-y: auto;
    list-style: none;
    padding: 0;
    z-index: 1000;
    box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  }

  .option {
    padding: 8px;
    cursor: pointer;
    border-radius: 15px;
    margin: 5px;
    text-transform: capitalize;
  }
    .options-list.bottom {
    top: 100%; /* Opens below the input */
    margin-top: 0px !important;
    }

  .option.highlighted {
    background: #917bf7;
    color: white;
  }
`;